import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api, get } from "@/lib/api";

const pill = { pending: "bg-blue-50 text-blue-800", approved: "bg-emerald-50 text-emerald-800", rejected: "bg-red-50 text-red-800" };

export const AdminSubmissions = () => {
  const qc = useQueryClient();
  const { data = [], isLoading } = useQuery({ queryKey: ["admin-submissions"], queryFn: () => get("/admin/submissions") });
  const act = async (id, action) => {
    try {
      if (action === "delete" && !window.confirm("Delete this submission?")) return;
      const { data: r } = action === "delete" ? await api.delete(`/admin/submissions/${id}`) : await api.post(`/admin/submissions/${id}/${action}`);
      toast.success({ approve: `Published as Pending Verification: ${r.url}`, reject: "Submission rejected", delete: "Submission deleted" }[action]);
      qc.invalidateQueries({ queryKey: ["admin-submissions"] });
      qc.invalidateQueries({ queryKey: ["admin-stats"] });
    } catch { toast.error("Action failed"); }
  };
  if (isLoading) return <p className="text-slate-600">Loading…</p>;
  if (!data.length) return <p className="text-slate-600" data-testid="admin-submissions-empty">No submissions yet.</p>;
  return (
    <div className="space-y-4" data-testid="admin-submissions-list">
      {data.map((s) => (
        <div key={s.id} className="rounded-2xl border border-[#E2E8F0] bg-white p-5" data-testid={`admin-submission-${s.id}`}>
          <div className="flex flex-wrap items-start justify-between gap-3">
            <div>
              <p className="font-semibold text-[#0B2150]">{s.hoa_name} <span className="text-sm font-normal text-slate-600">· {s.city}, {s.state}</span></p>
              <p className="text-xs text-slate-500 mt-1">By {s.submitter_name} ({s.submitter_email}) {s.relationship && `· ${s.relationship}`} · {new Date(s.created_at).toLocaleString()}</p>
            </div>
            <span className={`rounded-full px-3 py-1 text-xs font-semibold ${pill[s.status]}`}>{s.status}</span>
          </div>
          <dl className="mt-3 grid sm:grid-cols-4 gap-3 text-sm">
            <div><dt className="text-xs text-slate-500">Fee</dt><dd>{s.monthly_fee != null ? `$${s.monthly_fee} ${s.fee_frequency || ""}` : "—"}</dd></div>
            <div><dt className="text-xs text-slate-500">Pets</dt><dd>{s.pets_allowed == null ? "—" : s.pets_allowed ? "Yes" : "No"} {s.pet_policy}</dd></div>
            <div><dt className="text-xs text-slate-500">Rentals</dt><dd>{s.rental_policy || "—"} {s.rental_notes}</dd></div>
            <div><dt className="text-xs text-slate-500">Amenities</dt><dd>{s.amenities?.join(", ") || "—"}</dd></div>
          </dl>
          {s.notes && <p className="mt-3 text-sm text-[#334155]">{s.notes}</p>}
          <div className="mt-4 flex gap-2">
            {s.status === "pending" && <>
              <button onClick={() => act(s.id, "approve")} className="rounded-full bg-[#03A896] text-white px-4 py-1.5 text-sm font-semibold hover:bg-[#0B2150]" data-testid={`admin-approve-${s.id}`}>Approve & publish</button>
              <button onClick={() => act(s.id, "reject")} className="rounded-full border px-4 py-1.5 text-sm font-semibold hover:bg-red-50" data-testid={`admin-reject-${s.id}`}>Reject</button>
            </>}
            <button onClick={() => act(s.id, "delete")} className="rounded-full border px-4 py-1.5 text-sm font-semibold text-red-700 hover:bg-red-50" data-testid={`admin-delete-submission-${s.id}`}>Delete</button>
          </div>
        </div>
      ))}
    </div>
  );
};
